import { useTranslation } from 'react-i18next';
import { useSiteImage } from '@/hooks/useSiteImage';

export default function TheProblem() {
  const { t } = useTranslation();
  const imageUrl = useSiteImage('brandStory.problem.image', 'https://static.readdy.ai/image/16758960e7c0c7cf7b247f911f106b4f/828b0dc0fb1c402bdaee12182d277157.jpeg');

  return (
    <section className="w-full bg-white py-20 md:py-28 px-6 md:px-12 lg:px-20">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          {/* Left: Text */}
          <div className="flex flex-col gap-6">
            {/* Section label */}
            <div className="flex items-center gap-3">
              <div className="w-8 h-px bg-[#7B1113]" />
              <span className="text-[11px] tracking-[0.2em] uppercase text-[#7B1113] font-medium">
                {t('brandStory.problem.label')}
              </span>
            </div>

            <h2 className="font-serif text-3xl md:text-4xl lg:text-5xl font-bold text-[#2A2A2A] leading-[1.15]">
              {t('brandStory.problem.heading')}
            </h2>

            <div className="flex flex-col gap-4">
              <p className="text-sm text-[#8A8A8A] font-light leading-[1.9]">
                {t('brandStory.problem.p1')}
              </p>
              <p className="text-sm text-[#8A8A8A] font-light leading-[1.9]">
                {t('brandStory.problem.p2')}
              </p>
              <p className="text-sm text-[#8A8A8A] font-light leading-[1.9]">
                {t('brandStory.problem.p3')}
              </p>
            </div>

            {/* Stats */}
            <div className="grid grid-cols-3 gap-4 mt-4 pt-6 border-t border-[#F0EFED]">
              {[
                { value: t('brandStory.problem.stat1'), label: t('brandStory.problem.stat1Label') },
                { value: t('brandStory.problem.stat2'), label: t('brandStory.problem.stat2Label') },
                { value: t('brandStory.problem.stat3'), label: t('brandStory.problem.stat3Label') },
              ].map((stat) => (
                <div key={stat.label} className="flex flex-col gap-1.5">
                  <span className="text-lg font-serif font-semibold text-[#7B1113]">{stat.value}</span>
                  <span className="text-[10px] text-[#8A8A8A] font-light leading-[1.5]">{stat.label}</span>
                </div>
              ))}
            </div>
            <p className="text-[10px] italic text-[#8A8A8A]/60 font-light leading-[1.5] mt-2">
              *Source: Rx.K Seoul Internal Market Research, 2026. Full methodology available on request via the Contact page.*
            </p>
          </div>

          {/* Right: Image */}
          <div className="relative rounded-2xl overflow-hidden h-80 md:h-[480px]">
            <img
              src={imageUrl}
              alt="The counterfeit cosmetics problem in Bangladesh"
              className="w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-[#1A1A1A]/40 to-transparent" />
          </div>
        </div>
      </div>
    </section>
  );
}